import LabelPrimaryText from 'components/text/LabelPrimaryText';
import LargeSemiboldText from 'components/text/LargeSemiboldText';
import MediumText from 'components/text/MediumText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Button: FunctionComponent<Props> = ({
    children,
    className = '',
    disabled,
    icon,
    id,
    onClick,
    role,
    shape,
    size = 'md',
    testId = TEST_ID,
    type = 'button',
    variant = 'filled'
}: Props) => {
    const TextComponent =
        shape === 'pill' ? MediumText : size === 'sm' ? LabelPrimaryText : LargeSemiboldText;

    return (
        <button
            className={`${styles.button} ${styles[variant]} ${styles[size]}${shape === 'pill' ? ` ${styles.pill}` : ''} ${className}`}
            data-testid={testId}
            disabled={disabled}
            id={id}
            onClick={onClick}
            role={role}
            type={type}
        >
            {icon && <span className={styles.icon}>{icon}</span>}

            <TextComponent>{children}</TextComponent>
        </button>
    );
};

export default Button;
